// ForgotPasswordPage.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, Check, AlertCircle } from 'lucide-react';
import './AuthPages.css';

const API = process.env.REACT_APP_API_URL || "";

export default function ForgotPasswordPage() {
  //const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API}/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || 'Failed to send reset email');
      }

      setSuccess(true);
    } catch (err) {
      console.error('[ForgotPassword] Error:', err);
      setError(err.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-page">
        <div className="auth-container-modern">
          <div className="auth-header">
            <div className="auth-brand">
              <div className="brand-icon">
                <img src={`${process.env.PUBLIC_URL}/AdobeStock_133441382.png`} alt="Logo" className="brand-icon" />
              </div>
              <Link to="/" className="auth-link"><h1>BaoBrain</h1></Link>
            </div>
          </div>

          <div className="auth-success-container">
            <div className="success-icon-wrapper">
              <Check className="success-icon" size={48} />
            </div>
            <h2>Check your email</h2>
            <p className="success-message">
              We've sent a password reset link to <strong>{email}</strong>
            </p>
            <p className="success-subtitle">
              The link will expire in 1 hour. If you don't see the email, check your spam folder.
            </p>
            
            <div className="auth-footer" style={{ marginTop: '2rem' }}>
              <Link to="/login" className="auth-btn auth-btn-secondary">
                <ArrowLeft size={16} />
                Back to Login
              </Link>
            </div>
          </div>
        </div>

        <div className="auth-background">
          <div className="bg-shape shape-1"></div>
          <div className="bg-shape shape-2"></div>
          <div className="bg-shape shape-3"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container-modern">
        <div className="auth-header">
          <div className="auth-brand">
            <div className="brand-icon">
              <img src={`${process.env.PUBLIC_URL}/AdobeStock_133441382.png`} alt="Logo" className="brand-icon" />
            </div>
            <Link to="/" className="auth-link"><h1>BaoBrain</h1></Link>
          </div>
          <div className="auth-welcome">
            <h2>Forgot your password?</h2>
            <p>Enter your email address and we'll send you a reset link</p>
          </div>
        </div>

        <div className="auth-form-container">
          <form className="auth-form-modern" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <div className="input-wrapper">
                <Mail className="input-icon" size={20} />
                <input
                  id="email"
                  type="email"
                  placeholder="Enter your email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </div>
            </div>

            {error && (
              <div className="auth-error-modern">
                <AlertCircle size={16} />
                <span className="error-text">{error}</span>
              </div>
            )}

            <button
              type="submit"
              className="auth-btn auth-btn-primary"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="loading-spinner"></div>
                  Sending...
                </>
              ) : (
                'Send Reset Link'
              )}
            </button>
          </form>

          <div className="auth-footer">
            <p>
              Remember your password?{' '}
              <Link to="/login" className="auth-link">
                Back to Login
                <ArrowLeft size={14} style={{ marginLeft: '4px' }} />
              </Link>
            </p>
          </div>
        </div>
      </div>

      <div className="auth-background">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-shape shape-3"></div>
      </div>
    </div>
  );
}
